import { Box } from '@chakra-ui/react';
import { Login } from '@/components/Templates/Login';

const LoginPage = () => {
	return (
		<Box>
			<Login />
		</Box>
	);
};

export default LoginPage;
